<script lang="ts" setup>
type _VTI_TYPE_TComponentSize = 'xs' | 'lg' | 'md' | 'sm' | 'xl'
type ButtonVariant = 'solid' | 'outline' | 'soft' | 'ghost' | 'link'
type _VTI_TYPE_TComponentColor = 'primary' | 'secondary' | 'neutral' | 'green' | 'dark-gray' | 'error' | 'warning'
interface IButtonProps {
    label?: string;
    color?: _VTI_TYPE_TComponentColor;
    variant?: ButtonVariant;
    size?: _VTI_TYPE_TComponentSize;
    square?: boolean;
    block?: boolean;
    loadingAuto?: boolean;
    class?: string;
    loading?: boolean;
  }
  
  
  
  const props = defineProps<IButtonProps>();
  const attrs = useAttrs();
  const uiPayload = computed(() => ({ ...attrs, ...props }));
</script>

<template>
  <UButton
    :class="[attrs.class, props.class]"
    class="justify-center rounded-[6px] select-none cursor-pointer md:text-base text-white text-center font-bold font-barlow font-stretch-normal text-base leading-none"
    v-bind="uiPayload"
  >
    <slot></slot>
  </UButton>
</template>
